import CalculationMixin from 'trunks/vue/share/components/fields/calculation.js';
import FieldMixinForResponse from './mixin.js';

const Calculation = Vue.extend({
  mixins: [FieldMixinForResponse, CalculationMixin],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="form-field-value">
          <div v-if="valuePresent" class="controlled-input">
            {{ value }}
          </div>
          <div v-else class="controlled-input placeholder">
            暂无计算结果
          </div>
        </div>
      </template>
    </Field>
  `
});

export default Calculation;
